import { mapActions } from 'vuex'
import Input from '@/shared/components/Input'
import Toggle from '@/shared/components/Toggle'

export default {
  components: { Input, Toggle },
  props: {
    formId: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    options() {
      return this.item.options
    },
  },
  methods: {
    ...mapActions('landing', ['updateFormItem']),
    propChanged(path, value) {
      this.updateFormItem({
        id: this.formId,
        formItemId: this.item.id,
        path,
        value: value,
      })
    },
  },
}
